import { Button } from "@/components/ui/button";
import { X, LayoutTemplate } from "lucide-react";
import { SECTION_PRESETS } from "./presets";

export default function PresetGallery({ open, onClose, onInsert }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="preset-gallery">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200 sticky top-0 bg-white">
          <div className="font-heading font-bold text-slate-900 flex items-center gap-2"><LayoutTemplate size={18} className="text-[#E05638]" /> Sections prêtes à l'emploi</div>
          <button onClick={onClose} className="p-1 text-slate-400 hover:text-slate-700"><X size={18} /></button>
        </div>
        <div className="p-4 grid sm:grid-cols-2 gap-3">
          {SECTION_PRESETS.map((p) => (
            <button key={p.key} onClick={() => { onInsert(p.build()); onClose(); }} data-testid={`preset-${p.key}`}
              className="text-left rounded-xl border border-slate-200 p-4 hover:border-[#E05638] hover:shadow-sm transition">
              <div className="text-sm font-bold text-slate-900">{p.name}</div>
              <div className="text-xs text-slate-500 mt-0.5">{p.desc}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
